export const environment = {
  production: false,
  name: 'develop',
  widgetUrl: 'https://develop.rosie-web-widget.pages.dev/widget.js',
  api: {
    baseUrl: 'api-develop.heyrosie.dev'
  },
  adminUrl: 'https://develop.heyrosie.dev/admin',
  vapiPublicKey: '87722f85-6ed5-4397-b2c6-4aafebfbc8d0',
  sentryRelease: 'local_release',
  warmTransferNumber: '(659) 999-9698',
  rewardfulApiKey: 'fc9640',
  shopifyApiKey: '27dabf1f91bb69ba7494af589b4f218a',
  shopifyAdminUrl: 'https://admin.shopify.com',
  bingCustomerId: '',
  openAiPixelId: ''
};
